<template>
  <div>

    <el-dialog

        :visible="visible"
        @open="onOpen"
        v-loading="loading"
        class="gray-dialog"
        :before-close="close"
        width="560px">

      <div slot="title">
        <div class="el-dialog__title">Добавить бронь</div>
        <div class="el-dialog__subtitle">Пожалуйста, внимательно проверьте и заполните информацию о клиенте перед тем
          как продолжить работу
        </div>
      </div>

      <el-form
          :model="form"
          :rules="rulesSendCode"
          label-position="top"
          ref="sessionOpenForm"
          @keyup.enter.native="findClient"
          class="form-session">

        <el-form-item prop="phone" label="Номер телефона (последние 4 цифры)">
          <el-input name="phone" ref="phone"
                    v-model="form.phone"
                    v-mask="'+7-xxx-xxx-##-##'"
                    placeholder="+7-xxx-xxx-##-##"
                    auto-complete="off"></el-input>
        </el-form-item>

        <el-input name="phone" style="display: none" v-model="form.phone"></el-input>
      </el-form>

      <footer-buttons>
        <el-button type="primary"
                   @click="findClient"
                   :disabled="loading">Найти
        </el-button>
        <el-button @click="close">Закрыть</el-button>
      </footer-buttons>

      <div v-if="visibleResultSearch" class="result-search">
        <user-list :users="responseSearch" @openUser="goUser"/>
      </div>


    </el-dialog>


  </div>
</template>

<script>
import VueMask from "v-mask"
import Vue from "vue"

import UserList from "@/components/elements/ResultSearchUser/UserList"
import FooterButtons from "@/components/dialog/FooterButtons"
import {mapActions} from "vuex"

Vue.use(VueMask);

export default {
  name: "FindClient",
  data() {
    return {
      responseSearch: {},
      visibleResultSearch: false,
      loading: false,
      form: {
        phone: '+7-xxx-xxx-',
        code: null,
        department_id: null,
      },
      rulesSendCode: {
        phone: [{
          required: true,
          message: "Укажите номер",
          trigger: "blur"
        },
          {
            min: 16,
            max: 16,
            message: "Введите 4 последние цифры номера",
            trigger: "blur",
          },
        ]
      },
    };
  },
  props: {
    data: {
      required: true,
    },
    visible: {
      required: true,
    }
  },
  components: {
    UserList,
    FooterButtons
  },
  methods: {
    ...mapActions({
      setCurrentUser: "appointment/SET_CURRENT_USER",
      closeModal: "appointment/CLOSE_MODAL_FIND_CLIENT",
      openModalAppointment: "appointment/OPEN_MODAL_APPOINTMENT"
    }),
    findClient() {
      if (this.loading) return

      this.$refs.sessionOpenForm.validate((valid) => {
        if (valid) {
          this.loading = !0;
          this.$api.user.search({
            params: {
              phone: this.form.phone.replace("+7", "").replace(/[^\d]/g, ""),
            }
          }).then((response) => {
            if (response.data.length !== 0) {
              this.responseSearch = response.data
              this.visibleResultSearch = true
            } else {
              this.$notify.warning({
                title: "Никого не нашли 🔍",
                message: "Нет результатов",
              });
            }

          }).catch((response) => {
            this.$notify.error({
              title: "Ошибка поиска",
              message: response.response.data.message,
            });
          }).finally(() => {
            this.loading = !1;
          })
        } else {
          this.$nextTick(() => {
            this.$refs.phone.focus();
          })
        }
      })
    },
    goUser(data) {
      this.setCurrentUser(data)

      this.openModalAppointment()

      this.closeResultModal()
    },
    onOpen() {

      this.$nextTick(() => {
        this.$refs.phone.focus();
      })
    },
    onOpenResult() {


    },
    dateFor(d) {
      return new Date(d)
    },
    close() {
      this.closeModal()

      this.$emit("close");
    },
    closeResultModal() {
      this.visibleResultSearch = false

    }
  }
}
</script>

<style scoped lang="scss">
.result-search {

  margin: 24px 0 0 0;

  /deep/ .el-dialog {
    background: #efeff4;

  }

  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: -0.015em;
    color: #111;

  }
}

.form-session {
  margin-bottom: 28px;
}


</style>
